import Marquee from "react-fast-marquee";

const ITEMS = [
  "BRAND ACTIVATIONS",
  "MUSIC FESTIVALS",
  "PRODUCT LAUNCHES",
  "CORPORATE",
  "BESPOKE EXPERIENCES",
  "SPONSORSHIP",
  "ARTIST MANAGEMENT",
  "CONTENT & VISUALS",
];

export default function EditorialMarquee({ speed = 30 }) {
  return (
    <div className="relative py-8 md:py-12 border-y border-white/10 overflow-hidden bg-black">
      <Marquee gradient={false} speed={speed} pauseOnHover>
        {ITEMS.concat(ITEMS).map((t, i) => (
          <span
            key={i}
            className="font-display font-medium tracking-tight leading-none text-white/70 mx-6 md:mx-10 inline-flex items-center"
            style={{ fontSize: "clamp(1.25rem, 2.4vw, 2.2rem)" }}
          >
            {t}
            <span className="mx-5 md:mx-7 inline-block h-1.5 w-1.5 rounded-full bg-white/30" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
